module.exports = __webpack_public_path__ + "img/pc_bg.6914533.webp";